import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../app/store";
import {ConDesignItemWithPicture, PaginatedCDIsLite} from "../types/ConDesignItem";

interface DesignItemsSliceState {
	items: ConDesignItemWithPicture[];
	itemsLite: PaginatedCDIsLite;
}

interface DesignItemsPayload {
	data: PaginatedCDIsLite;
	isShowMoreClicked: boolean;
}

const initialState: DesignItemsSliceState = {
	items: [],
	itemsLite: {
		designItems: [],
		isLastPage: null,
		pageSize: 40,
		totalItems: null,
	},
};

export const designItemsSlice = createSlice({
	name: "designItems",
	initialState,
	reducers: {
		setDesignItemsLite: (state, action: PayloadAction<DesignItemsPayload>) => {
			const addDesignItems = () => {
				action.payload.data.designItems.forEach((designItem) => {
					if (!state.itemsLite.designItems.some((item) => item.id === designItem.id)) {
						state.itemsLite.designItems.push(designItem);
					}
				});
			};
			if (action.payload.isShowMoreClicked && action.payload.data) {
				state.itemsLite.totalItems = action.payload.data.totalItems;
				
				if (state.itemsLite.designItems && action.payload.data.designItems) {
					addDesignItems();
				}
			} else if (action.payload.data) {
				state.itemsLite.totalItems = action.payload.data.totalItems;
				state.itemsLite.designItems = [];
				addDesignItems();
			}
		},
		setIsLastPage: (state, action: PayloadAction<boolean | null>) => {
			state.itemsLite.isLastPage = action.payload;
		}
	},
});

export const {
	setDesignItemsLite,
	setIsLastPage,
} = designItemsSlice.actions;


export const selectItemsLite = (state: RootState) => state.itemsLite.itemsLite;
